import { UPDATE_APP_SESSION } from "./app-session/index.js";
import {
  CREATE_APP_SESSION_CELL,
  UPDATE_APP_SESSION_CELL,
} from "./app-session-cell/index.js";
import { AppSessionEventDefinition } from "./AppSessionEventDefinition.js";
import {
  CLEAR_ALL_OUTPUTS,
  CLEAR_OUTPUTS,
  CREATE_OUTPUT,
  DELETE_OUTPUT,
  REPLACE_OUTPUT_CONTENTS,
} from "./output/index.js";
import { CREATE_OUTPUT_CONTENT } from "./output-content/index.js";
import { DELETE_SCOPE_ITEM, UPSERT_SCOPE_ITEM } from "./scope-item/index.js";

/* eslint-disable @typescript-eslint/no-explicit-any -- any is useful for generic interfaces */

/**
 * An app session event represents any change to the app session event state.
 *
 * The present state is just a sum of all previous states
 */
export interface AppSessionEvent<
  TYPE extends string,
  PAYLOAD extends Record<string, any>,
> {
  /**
   * Discriminant that makes it easy to determine the type of app session event
   */
  type: TYPE;

  /**
   * The actual contents of the event
   */
  payload: PAYLOAD;
}

export const AppSessionEvent = {
  [UPDATE_APP_SESSION.type]: UPDATE_APP_SESSION,
  [CREATE_APP_SESSION_CELL.type]: CREATE_APP_SESSION_CELL,
  [UPDATE_APP_SESSION_CELL.type]: UPDATE_APP_SESSION_CELL,
  [CREATE_OUTPUT.type]: CREATE_OUTPUT,
  [DELETE_OUTPUT.type]: DELETE_OUTPUT,
  [REPLACE_OUTPUT_CONTENTS.type]: REPLACE_OUTPUT_CONTENTS,
  [CLEAR_ALL_OUTPUTS.type]: CLEAR_ALL_OUTPUTS,
  [CLEAR_OUTPUTS.type]: CLEAR_OUTPUTS,
  [CREATE_OUTPUT_CONTENT.type]: CREATE_OUTPUT_CONTENT,
  [DELETE_SCOPE_ITEM.type]: DELETE_SCOPE_ITEM,
  [UPSERT_SCOPE_ITEM.type]: UPSERT_SCOPE_ITEM,
} satisfies {
  [TYPE: string]: AppSessionEventDefinition<AppSessionEvent<any, any>, any>;
};

/**
 * Exhaustive type for all possible app session events
 */
export type ExhaustiveAppSessionEvent = ReturnType<
  (typeof AppSessionEvent)[keyof typeof AppSessionEvent]["create"]
>;
